var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsuranceMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10806",
    "data-name": "Grupo 10806",
    transform: "translate(1512 -230)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-briefcase-medical",
    "data-name": "Icon awesome-briefcase-medical",
    d: "M16.313,5.625H13.5V3.938A1.688,1.688,0,0,0,11.813,2.25H6.188A1.688,1.688,0,0,0,4.5,3.938V5.625H1.688A1.688,1.688,0,0,0,0,7.313V17.438a1.688,1.688,0,0,0,1.688,1.688H16.313A1.688,1.688,0,0,0,18,17.438V7.313A1.688,1.688,0,0,0,16.313,5.625ZM6.75,4.5h4.5V5.625H6.75Zm5.625,8.719a.282.282,0,0,1-.281.281H10.125v1.969a.282.282,0,0,1-.281.281H8.156a.282.282,0,0,1-.281-.281V13.5H5.906a.282.282,0,0,1-.281-.281V11.531a.282.282,0,0,1,.281-.281H7.875V9.281A.282.282,0,0,1,8.156,9H9.844a.282.282,0,0,1,.281.281V11.25h1.969a.282.282,0,0,1,.281.281Z",
    transform: "translate(-1505.367 234.313)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_17737",
    "data-name": "Rect\\xE1ngulo 17737",
    width: 30,
    height: 30,
    transform: "translate(-1512 230)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuranceMenu);
export default __webpack_public_path__ + "static/media/insurance-menu.b5e7f69028163b7dbf5d3f7afd5ad356.svg";
export { ForwardRef as ReactComponent };